import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./Pages/Home";
import Menu from "./Pages/Menu";
import Salon from "./Pages/Salon";
import HotelFacilities from "./Pages/HotelFacilities";
import Cars from "./Pages/Cars";
import Services from "./Pages/Services";
import Events from "./Pages/Events";
import Activities from "./Pages/Activities";

import ProductPage from "./Pages/ProductPage";
import CompanyPage from "./Pages/CompanyPage.js";

import Navbar from "./Components/Navbar";
import RoomService from "./Pages/RoomService";
import RentCar from "./Pages/RentCar.js";
import Ride from "./Pages/Ride.js";
import Salons from "./Pages/Salons.js";
import OutsideSpa from "./Pages/OutsideSpa.js";
import Tourist from "./Pages/Tourist.js";
import BodyGuard from "./Pages/BodyGuard.js";
import { CartProvider } from "./context/CartContext";
import CartPage from "./Pages/CartPage.js";
import Companyexample from "./Pages/Companyexample.js";

function App() {
  return (
    <Router>
          <CartProvider>

      <div className="p-4">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
   <Route path="/CartPage" element={<CartPage />} />

          {/* Hotel Facilities */}
          <Route path="/hotel-facilities" element={<HotelFacilities />} />
          <Route path="/menu" element={<Menu />} />

          <Route path="/room-service" element={<RoomService />} />
          <Route path="/salon" element={<Salon />} />
<Route path="/services" element={<Services />} />
<Route path="/salons" element={<Salons />} />
<Route path="/outside-spa" element={<OutsideSpa />} />
<Route path="/tourist" element={<Tourist />} />
<Route path="/body-guard" element={<BodyGuard />} />
          {/* Cars */}
  <Route path="/cars" element={<Cars />} />
  <Route path="/cars/rent-car" element={<RentCar />} />
  <Route path="/cars/ride" element={<Ride />} />

          {/* Services */}
          <Route path="/services" element={<Services />} />

          {/* Events & Activities */}
          <Route path="/events" element={<Events />} />
          <Route path="/activities" element={<Activities />} />



          {/* Dynamic Product & Company */}
          <Route path="/product/:productId" element={<ProductPage />} />
          <Route path="/company/:companyId" element={<CompanyPage />} />
          <Route path="/companyexample" element={<Companyexample />} />

        </Routes>
      </div>
       </CartProvider>
    </Router>
  );
}

export default App;